// frontend/klaes-app/src/components/FilmFavs/components/TagPicker.jsx
import { useState } from 'react';
import { FiX, FiCheck, FiPlus } from 'react-icons/fi';
import { Chip } from './Chip';
import { tagCategories, categoryColors } from '../utils/helpers';
import styles from '../FilmFavs.module.css';

export const TagPicker = ({ 
  onSelectTag,   // wird aufgerufen mit (tag) – hier Toggle-Logik
  onClose, 
  existingTags, 
  onCreateTag, 
  selectedTags = []   // Array der aktuell ausgewählten Tags (für Hervorhebung)
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [newTagName, setNewTagName] = useState('');
  const [showCreateTag, setShowCreateTag] = useState(false);

  const filteredTags = existingTags.filter(tag => {
    const matchesCategory = selectedCategory === 'all' || tag.category === selectedCategory;
    const matchesSearch = searchTerm === '' || tag.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const tagExists = existingTags.some(tag => 
    tag.name.toLowerCase() === searchTerm.toLowerCase()
  );

  const handleCreateTag = () => {
    if (newTagName.trim() && selectedCategory !== 'all') {
      onCreateTag({
        name: newTagName.trim(),
        category: selectedCategory,
        colour: categoryColors[selectedCategory] || '#6366f1'
      });
      setNewTagName('');
      setShowCreateTag(false);
      setSearchTerm('');
    }
  };

  const handleStartCreate = () => {
    if (searchTerm && !tagExists && selectedCategory !== 'all') {
      setNewTagName(searchTerm);
      setShowCreateTag(true);
    }
  };

  // Gruppierte Anzeige für Kategorie "Alle"
  const groupedTags = filteredTags.reduce((acc, tag) => {
    if (!acc[tag.category]) acc[tag.category] = [];
    acc[tag.category].push(tag);
    return acc;
  }, {});

  const isSelected = (tag) => selectedTags.some(t => t.name === tag.name);

  const handleTagClick = (tag) => {
    onSelectTag(tag);   // Toggle-Logik wird in der Elternkomponente implementiert
  };

  const handleConfirmClose = () => {
    onClose();  // Übernehmen + schließen
  };

  return (
    <div className={styles.tagPickerOverlay} onClick={onClose}>
      <div className={styles.tagPicker} onClick={(e) => e.stopPropagation()}>
        <div className={styles.tagPickerHeader}>
          <h4>Tags auswählen / erstellen</h4>
          <div className={styles.headerButtons}>
            <button onClick={handleConfirmClose} className={styles.confirmPickerBtn} title="Übernehmen">
              <FiCheck />
            </button>
            <button onClick={onClose} className={styles.closePickerBtn}>
              <FiX />
            </button>
          </div>
        </div>

        <div className={styles.tagPickerSearch}>
          <input 
            type="text" 
            placeholder="Tag suchen oder neuen erstellen..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleStartCreate()}
            className={styles.tagPickerInput}
          />
        </div>

        <div className={styles.tagPickerCategories}>
          {tagCategories.map(cat => (
            <button 
              key={cat.id}
              className={`${styles.categoryBtn} ${selectedCategory === cat.id ? styles.active : ''}`}
              onClick={() => setSelectedCategory(cat.id)}
            >
              <span>{cat.icon}</span> {cat.label}
            </button>
          ))}
        </div>

        <div className={styles.tagPickerList}>
          {showCreateTag && (
            <div className={styles.createTagModal}>
              <p>Neuen Tag erstellen:</p>
              <div className={styles.createTagForm}>
                <input 
                  type="text" 
                  value={newTagName} 
                  onChange={(e) => setNewTagName(e.target.value)}
                  placeholder="Tag Name"
                  autoFocus
                />
                <div className={styles.createTagCategory}>
                  <span>Kategorie: {tagCategories.find(c => c.id === selectedCategory)?.label}</span>
                </div>
                <div className={styles.createTagButtons}>
                  <button onClick={handleCreateTag} className={styles.confirmCreateBtn}>Erstellen</button>
                  <button onClick={() => setShowCreateTag(false)} className={styles.cancelCreateBtn}>Abbrechen</button>
                </div>
              </div>
            </div>
          )}

          {selectedCategory === 'all' ? (
            Object.entries(groupedTags).map(([category, tags]) => (
              <div key={category} className={styles.tagCategoryGroup}>
                <div className={styles.tagCategoryLabel}>
                  {tagCategories.find(c => c.id === category)?.icon} {tagCategories.find(c => c.id === category)?.label || category}
                </div>
                <div className={styles.tagPickerTags}>
                  {tags.map(tag => (
                    <Chip 
                      key={tag.name} 
                      label={tag.name} 
                      category={tag.category}
                      isSelected={isSelected(tag)}
                      onClick={() => handleTagClick(tag)}
                      size="medium"
                    />
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div className={styles.tagPickerTags}>
              {(groupedTags[selectedCategory] || []).map(tag => (
                <Chip 
                  key={tag.name} 
                  label={tag.name} 
                  category={tag.category}
                  isSelected={isSelected(tag)}
                  onClick={() => handleTagClick(tag)}
                  size="medium"
                />
              ))}
              {!showCreateTag && searchTerm && !tagExists && (
                <button onClick={handleStartCreate} className={styles.createNewTagHint}>
                  <FiPlus /> "{searchTerm}" als neuen Tag erstellen
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};